export type RoleMode = 'any' | 'all';

export function hasRole(
  userRoles: readonly string[],
  required: readonly string[] | undefined,
  mode: RoleMode,
): boolean {
  if (!required || required.length === 0) return true;
  if (mode === 'all') return required.every((r) => userRoles.includes(r));
  return required.some((r) => userRoles.includes(r));
}
